
































import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { IDocumentImageSource } from "../../../domain/document";
import {
  AbstractItem,
  instanceOfIDrawableItem,
  IClickHandleable,
  instanceOfIClickHandleable,
} from "../../../domain/document/items";
import { DragKinds } from "../../dragging/DragKinds";
import { IDrawableItemEditable, instanceOfIDrawableItemEditable } from "./IDrawableItemEditable";
import { ObjectMarkKinds } from "./ObjectMarkKinds";
// TODO: ここもindex.ts作成して一まとめにしたかったが上手くいかない.後で調査.
import LineObject from "./objects/LineObject.vue";
import PolylineObject from "./objects/PolylineObject.vue";
import MovableTextBoxObject from "./objects/MovableTextBoxObject.vue";
import RichTextBoxObject from "./objects/RichTextBoxObject.vue";
import BoxLineObject from "./objects/BoxLineObject.vue";
import CircleObject from "./objects/CircleObject.vue";
import TriangleObject from "./objects/TriangleObject.vue";
import CrossObject from "./objects/CrossObject.vue";
import DateObject from "./objects/DateObject.vue";
import CircleSelectObject from "./objects/CircleSelectObject.vue";
import CalculateObject from "./objects/CalculateObject.vue";
import ComboBoxObject from "./objects/ComboBoxObject.vue";
import ImageObject from "./objects/ImageObject.vue";
import SignObject from "./objects/SignObject.vue";
import CheckBoxObject from "./objects/CheckBoxObject.vue";
import NotImplementedObject from "./objects/NotImplementedObject.vue";
import RollObject from "./objects/RollObject.vue";
import ExternalDataObject from "./objects/ExternalDataObject.vue";
import ExternalProcessObject from "./objects/ExternalProcessObject.vue";
import BarcodeObject from "./objects/BarcodeObject.vue";
import PositionCorrectObject from "./objects/PositionCorrectObject.vue";
import MovableImageObject from "./objects/MovableImageObject.vue";
import TextBoxWrapperObject from "./objects/TextBoxWrapperObject.vue";
import NewPageObject from "./objects/NewPageObject.vue";
import GraphObject from "./objects/GraphObject.vue";
import RangeOfMotionObject from "./objects/RangeOfMotionObject.vue";
import JoinTextObject from "./objects/JoinTextObject.vue";
import BarObject from "./objects/BarObject.vue";
import StampObject from "./objects/StampObject.vue";

@Component({
  components: {
    // ここに文書オブジェクトコンポーネントを記載要.DocuCoreとして考えると標準以外の文書オブジェクトをどうサポートするか？要検討.
    LineItem: LineObject,
    PolylineItem: PolylineObject,
    TextBoxItem: TextBoxWrapperObject,
    MovableTextBoxItem: MovableTextBoxObject,
    RichTextBoxItem: RichTextBoxObject,
    BoxLineItem: BoxLineObject,
    CircleItem: CircleObject,
    TriangleItem: TriangleObject,
    CrossItem: CrossObject,
    DateItem: DateObject,
    CircleSelectItem: CircleSelectObject,
    CalculateItem: CalculateObject,
    ComboBoxItem: ComboBoxObject,
    ImageItem: ImageObject,
    SignItem: SignObject,
    CheckBoxItem: CheckBoxObject,
    NotImplementedItem: NotImplementedObject,
    RollItem: RollObject,
    ExternalDataItem: ExternalDataObject,
    ExternalProcessItem: ExternalProcessObject,
    BarcodeItem: BarcodeObject,
    PositionCorrectItem: PositionCorrectObject,
    MovableImageItem: MovableImageObject,
    NewPageItem: NewPageObject,
    GraphItem: GraphObject,
    RangeOfMotionItem: RangeOfMotionObject,
    HeaderFooterTextItem: NotImplementedObject,
    JoinTextItem: JoinTextObject,
    BarItem: BarObject,
    StampItem: StampObject,
  }
})
export default class DrawableObject extends Mixins() implements IClickHandleable {
  @Prop()
  source: AbstractItem;

  @Prop()
  shouldDrawEditStyle: boolean;

  @Prop()
  shouldDrawTransparentAll: boolean;

  @Prop()
  isFocused: boolean;

  @Prop()
  shouldInputFreeAll: boolean;

  @Prop({ default: false })
  shouldStopMouseDown: boolean;

  @Prop()
  objectMarkKind: ObjectMarkKinds;

  @Prop()
  shouldMarkQuote: boolean;

  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  @Prop({ default: 1 })
  scale: number;

  onMouseDowned(event: PointerEvent): void {
    this.pointerdown(this.$refs.obj as any, event);
    // 動的引数はv2.5.2では使えない.(v.2.6.0以降.)ベタにstopPropagation()を呼ぶ.
    if (this.shouldStopMouseDown) {
      event.stopPropagation();
    }
  }

  get key(): string {
    return this.source.typeKey;
  }

  get editingSource(): AbstractItem {
    return this.source;
  }

  set editingSource(value: AbstractItem) {
    this.updateSource(value);
  }

  get shouldShowMark(): boolean {
    return !!this.objectMarkKind;
  }

  get badgeType(): string {
    // 公式リファレンスの例ではtype指定するだけで色が変わるように書いてあるが、
    // el-badge__content--{type}のcssを指定しないと効かない模様
    switch (this.objectMarkKind) {
      case ObjectMarkKinds.Warning:
        return "warning";
      case ObjectMarkKinds.Error:
      default:
        return "danger";
    }
  }

  get markAlertStyleProperties(): any {
    if (!instanceOfIDrawableItem(this.source)) {
      return null;
    }
    const rectangle = this.source.geometry.rectangle;
    return {
      left: (rectangle.x + rectangle.width - 10) + "px",
      top: rectangle.y + "px",
    };
  }

  @Emit()
  mouseenter(sender: IDrawableItemEditable, event: PointerEvent): any {}

  @Emit()
  mouseleave(sender: IDrawableItemEditable, event: PointerEvent): any {}

  @Emit()
  updateSource(item: AbstractItem): any {}

  @Emit()
  focus(source: IDrawableItemEditable): void {}

  @Emit()
  loseFocus(source: IDrawableItemEditable): void {}

  @Emit()
  selectItemHandle(item: AbstractItem, offsetX: number, offsetY: number, dragKind: DragKinds): any {}

  @Emit()
  pointerdown(sender: IDrawableItemEditable, event: PointerEvent): any {}

  @Watch("isFocused")
  onIsFocusedUpdated(newValue: boolean, oldValue: boolean) {
    if (newValue && instanceOfIDrawableItemEditable(this.$refs.obj)) {
      this.focus(this.$refs.obj);
    }
  }

/* ソースの更新でログを出力してたが連鎖や高さ調整等で大量のオブジェクト(350程度)が更新されるとこれでも数百msecかかりそう.デバッグでは使いたいのでコメントアウトしておく.
  @Watch("source")
  onSourceUpdated(newValue: AbstractItem, oldValue: AbstractItem) {
    this.$logger.debug(
      "オブジェクトソース更新: "
      + (newValue ? (newValue.privateId + " / " + newValue.id) : ""));
  }
*/

  mounted(): void {
    if (this.isFocused && instanceOfIDrawableItemEditable(this.$refs.obj)) {
      this.focus(this.$refs.obj);
    }
  }

  onFocused(source: IDrawableItemEditable): void {
    this.focus(source);
  }

  onFocusLost(source: IDrawableItemEditable): void {
    this.loseFocus(source);
  }

  itemHandleSelected(item: AbstractItem, offsetX: number, offsetY: number, dragKind: DragKinds): void {
    this.selectItemHandle(item, offsetX, offsetY, dragKind);
  }

  clicked(): void {
    if (instanceOfIClickHandleable(this.$refs.obj)) {
      this.$refs.obj.clicked();
    }
  }
}
